import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {StockTransferM} from "../model/stock_transfer.model";
import {StockCheckDetailM} from "../model/stock_check_detail.model";
import {StockTransferDetailM} from "../model/stock_transfer_detail.model";
import {Util} from "../util/util";

@Injectable()
export class StockTransferService {

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(type: string, detail_type: string, searchStr: string, status: string, status_payment: string, seller_id: number = 0, shipping_id: number = 0, sales_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/stock/transfer/list?type=${type}&detail_type=${detail_type}&searchStr=${searchStr}&status=${status}&status_payment=${status_payment}&seller_id=${seller_id}&shipping_id=${shipping_id}&sales_id=${sales_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getDetail(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/stock/transfer/detail/${bill_no}`, this.options).map(res => res.json());
  }

  getDetailById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/stock/transfer/detail/${id}`, this.options).map(res => res.json());
  }


  create(stockCheckM: StockTransferM) {
    this.reloadToken()
    return this.http.post(`/api/stock/transfer`, stockCheckM, this.options).map(res => res.json());
  }

  addTransferStockByBarcodeNo(stock_transfer_id, stockTransferDetail: StockTransferDetailM) {
    this.reloadToken()
    return this.http.post(`/api/stock/transfer/addTransferStock/${stock_transfer_id}`, stockTransferDetail, this.options).map(res => res.json());
  }

  transferStockByBarcodeNo(id: number, barcode: string) {
    this.reloadToken()
    return this.http.put(`/api/stock/transfer/transferStock/${id}`, {product_barcode: barcode}, this.options).map(res => res.json());
  }

  cancelAcceptTransferById(id: number) {
    this.reloadToken()
    return this.http.put(`/api/stock/transfer/cancelAcceptTransfer/${id}`, {}, this.options).map(res => res.json());
  }

  update(stockCheckM: StockTransferM) {
    this.reloadToken()
    return this.http.put(`/api/stock/transfer/detail/${stockCheckM.id}`, stockCheckM, this.options).map(res => res.json());
  }

  updateStatus(stockCheck_id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/stock/transfer/status/${stockCheck_id}/${status}`, {}, this.options).map(res => res.json());
  }

  getStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/stock/transfer/getStatusCount`, this.options).map(res => res.json());
  }

  deleteDetail(id: number) {
    this.reloadToken()
    return this.http.delete(`/api/stock/transfer/detail/${id}`, this.options).map(res => res.json());
  }

  delete(id: number) {
    this.reloadToken()
    return this.http.delete(`/api/stock/transfer/${id}`, this.options).map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/stock-transfer.service.ts